/**
 * UI交互配置
 * 职责：UI组件、交互相关配置
 */

export const UI_CONFIG = {
  // Toast配置
  TOAST: {
    DEFAULT_DURATION: 3000,
    SUCCESS_DURATION: 2000,
    ERROR_DURATION: 4000,
    WARNING_DURATION: 3000,
    INFO_DURATION: 3000,
    MAX_COUNT: 3,
    POSITION: 'top-right',
  },
  
  // 分页配置
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 10,
    PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
    SHOW_QUICK_JUMPER: true,
    SHOW_TOTAL: true,
    SHOW_SIZE_CHANGER: true,
  },
  
  // 表格配置
  TABLE: {
    DEFAULT_PAGE_SIZE: 10,
    SCROLL_Y: 600,
    ROW_HEIGHT: 48,
  },
  
  // 模态框配置
  MODAL: {
    DEFAULT_WIDTH: 600,
    MASK_CLOSABLE: true,
    KEYBOARD: true,
  },
  
  // 动画配置
  ANIMATION: {
    DURATION: 300,
    EASE: 'ease-in-out',
  },
  
  // 响应式断点
  BREAKPOINTS: {
    XS: 480,
    SM: 576,
    MD: 768,
    LG: 992,
    XL: 1200,
    XXL: 1600,
  },
};

export default UI_CONFIG;

